export const EnquiryClicked = 'Enquiry Clicked';
export const MortgageEnquiryImpression = 'KPR Listing Enquiry Impression';
export const MortgageEnquirySubmit = 'KPR Listing Enquiry Submit';
